function view_start_order() {
  // window.location.href = "/locations"; 
  ecw_show_loading();
  $contentContainer
    .load(templateRoot + "wf-ordering-start-order.html", function () {
      localStorage.removeItem('ecw_confirm_location');
      localStorage.removeItem('ecw_visitor_store_latitude');
      localStorage.removeItem('ecw_visitor_store_longitude');

      // console.log('load wf-ordering-start-order.html');
      
      initMap();
      onloadStartOrderStuff();

    })
    .hide()
    .fadeIn(transitionDuration);
}